<template>
  <div class="main-gis-wms-map-swipe">
    <div class="content-gis-map">
      <div
        :id="`${nameMap}_${initialDate}`"
        :style="minHeight"
      />
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '@fortawesome/fontawesome-free';
import 'leaflet-side-by-side';
import { mapState, mapActions } from 'vuex';
import EventBus from '../../../js/event-bus';

export default {
  name: 'GISWMSSwipeMap',
  props: {
    zoom: { type: Number, default: 1 },
    height: { type: String, default: '450px' },
    nameMap: { type: String, default: '' },
    optionsLeftKey: { type: String, default: 'Left' },
    optionsRightKey: { type: String, default: 'Right' },
    treeLocations: {
      type: Array,
      default: () => [],
    },
    indexes: {
      type: Array,
      default: () => ['NDVI', 'NDVI'], // [0] Left, [1] Right
    },
    layer: {
      type: Object,
      default: () => {},
    },
    center: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentLayerBase: {},
      map: null,
      initialDate: Date.now(),
      currentLayers: [],
      leftSwipeLayer: null,
      rightSwipeLayer: null,
      rightTextbox: null,
      leftTextbox: null,
    };
  },
  computed: {
    minHeight() {
      return `min-height: ${this.height}`;
    },
    ...mapState('Gis', [
      'osm',
      'googleHybrid',
      'currentOverlayLayer',
      'featureInfo',
      'datesList',
    ]),
    ...mapState('Plantation', ['currentPlantation']),
  },
  beforeMount() {
    EventBus.$on(`indexLayer${this.optionsLeftKey}`, this.indexLayerLeft);
    EventBus.$on(`updateDateLayer${this.optionsLeftKey}`, this.dateLayerLeft);
    EventBus.$on(`indexLayer${this.optionsRightKey}`, this.indexLayerRight);
    EventBus.$on(`updateDateLayer${this.optionsRightKey}`, this.dateLayerRight);
  },
  mounted() {
    this.setCurrentLayersMap([]);
    this.renderMap();
    this.addFuncionalities();
    this.addOverlayLayer();
    this.updateLayer();
  },
  methods: {
    /**
     * Añadimos una capa tanto de tipo GeoJson como WMS a la lista de capas activas
     */
    async addOverlayLayer() {
      this.$f7.preloader.show();
      try {
        const layer = L.tileLayer.wms(this.layer.baseUrl, this.layer.options);
        this.map.setView([this.center.latitude, this.center.longitude], this.zoom);

        const item = this.layer;
        this.createSwipe(item);
        this.currentLayers.push({ item, layer });
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },

    async updateLayer() {
      this.$f7.preloader.show();
      try {
        const currentOverlayLayer = this.layer.options.layers.split(':')[1];
        await this.fetchDatesLayer(currentOverlayLayer);
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
        const lastDate = this.datesList.avaiable_dates.pop();
        const newFormatDate = this.formatDate(lastDate);
        this.addTimeRightTextToMap(newFormatDate);
        this.addTimeLeftTextToMap(newFormatDate);
      }
    },

    /**
     * Anidamos los datos para adjuntar en la ruta.
     */
    generateRouteTocenterMapWMSLayer(item) {
      const layersArray = item.options.layers.split(':');
      if (layersArray.length < 2) return '';
      const fullUrl = `getbbox/?ws=${layersArray[0]}&layer=${layersArray[1]}&ds=${item.ds}`;
      return fullUrl;
    },

    /**
     *
     */
    async dataRequestWMSLayers(route, e) {
      await this.fetchFeatureInfo({ queryParams: `wms/${route}` });
      if (!('features' in this.featureInfo) || !this.featureInfo.features.length) {
        // return false;
      } else {
        const features = this.featureInfo.features[0];
        const { properties } = features;

        this.openLayerDataPopup(properties, e);
      }
    },

    /**
     *
     */
    generateRouteToDataRequestWMSLayers(item, e) {
      const BBOX = `${e.latlng.lng - 0.00002},${e.latlng.lat - 0.00002},${e.latlng.lng + 0.00002},${e.latlng.lat + 0.00002}`;
      const queryParams = {
        REQUEST: 'GetFeatureInfo',
        SRS: 'EPSG:4326',
        BBOX,
        HEIGHT: this.map.getSize().y,
        WIDTH: this.map.getSize().x,
        LAYERS: item.options.layers,
        QUERY_LAYERS: item.options.layers,
        INFO_FORMAT: 'application/json',
        X: Math.round(this.map.layerPointToContainerPoint(e.layerPoint).x),
        Y: Math.round(this.map.layerPointToContainerPoint(e.layerPoint).y),
      };

      const fullUrl = L.Util.getParamString(queryParams);
      this.dataRequestWMSLayers(fullUrl, e);
    },

    indexLayerLeft(index) {
      this.leftSwipeLayer.setParams({
        styles: index,
      }).addTo(this.map);
    },

    dateLayerLeft(date) {
      this.leftSwipeLayer.setParams({
        time: date,
      }).addTo(this.map);
      const newFormatDate = this.formatDate(date);
      this.addTimeLeftTextToMap(newFormatDate);
    },

    indexLayerRight(index) {
      this.rightSwipeLayer.setParams({
        styles: index,
      }).addTo(this.map);
    },

    dateLayerRight(date) {
      this.rightSwipeLayer.setParams({
        time: date,
      }).addTo(this.map);
      const newFormatDate = this.formatDate(date);
      this.addTimeRightTextToMap(newFormatDate);
    },

    createSwipe(item) {
      const url = item.baseUrl;
      const leftItem = {
        baseUrl: url,
        options: {
          layers: item.options.layers,
          format: 'image/png',
          transparent: true,
          styles: this.indexes[0],
        },
      };

      const rightItem = {
        baseUrl: url,
        options: {
          layers: item.options.layers,
          format: 'image/png',
          transparent: true,
          styles: this.indexes[1],
        },
      };
      this.leftSwipeLayer = L.tileLayer.wms(leftItem.baseUrl, leftItem.options).addTo(this.map);
      this.rightSwipeLayer = L.tileLayer.wms(rightItem.baseUrl, rightItem.options).addTo(this.map);
      const swipeControl = L.control.sideBySide(this.leftSwipeLayer, this.rightSwipeLayer);
      swipeControl.addTo(this.map);
    },

    formatDate(date) {
      const dateObject = new Date(date);
      const day = dateObject.getDate();
      const month = dateObject.getMonth() + 1;
      const year = dateObject.getFullYear();
      const newFormatDate = `${day}/${month}/${year}`;
      return newFormatDate;
    },

    renderMap() {
      this.map = L.map(`${this.nameMap}_${this.initialDate}`);
      L.tileLayer(this.googleHybrid.route, this.googleHybrid.properties).addTo(this.map);
      this.currentLayerBase = L.tileLayer(this.googleHybrid.route, this.googleHybrid.properties).addTo(this.map);
      this.currentLayerBase.bringToBack();
    },

    addFuncionalities() {
      const self = this;
      try {
        L.control.scale().addTo(self.map);
        self.map.attributionControl.addAttribution(
          'Thäles from <a href="https://hispatecanalytics.com//">HispatecAnalytics SA</a>',
        );
        L.Control.zoomHome = L.Control.extend({
          options: {
            position: 'topleft',
            zoomHomeText: '<i class="fa fa-home" style="line-height:1.65 blue;"></i>',
            zoomHomeTitle: 'Zoom home',
          },
          onAdd() {
            const controlName = 'gin-control-zoom';
            const container = L.DomUtil.create('div', `${controlName} leaflet-bar`);
            const { options } = this;
            // eslint-disable-next-line no-underscore-dangle
            this._zoomHomeButton = this.createButton(options.zoomHomeText, options.zoomHomeTitle,
              `${controlName}-home`, container, this.zoomHome);

            return container;
          },

          zoomHome() {
            self.map.setView([self.center.latitude, self.center.longitude], self.zoom);
          },

          createButton(html, title, className, container, fn) {
            const link = L.DomUtil.create('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            L.DomEvent.on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
              .on(link, 'click', L.DomEvent.stop)
              .on(link, 'click', fn, this);
            return link;
          },
        });
        // eslint-disable-next-line new-cap
        const zoomHome = new L.Control.zoomHome();
        zoomHome.addTo(self.map);

        L.Control.legend = L.Control.extend({
          options: {
            position: 'bottomright',
          },
          onAdd() {
            self.map.legend = this;

            const container = L.DomUtil.create('div', 'legend-control-container');

            if (this.options.content) {
              container.innerHTML = this.options.content;
            }
            return container;
          },
          onRemove() {
            delete self.map.legend;
          },

          setContent(str) {
            this.getContainer().innerHTML = str;
          },
        });
        // eslint-disable-next-line new-cap
        const legend = new L.Control.legend();
        legend.addTo(self.map);
      } catch (e) {
        this.$f7.dialog.alert(e);
      }
    },
    addTimeRightTextToMap(date) {
      const self = this;
      L.Control.textbox = L.Control.extend({
        options: {
          position: 'topright',
        },
        onAdd() {
          const text = L.DomUtil.create('div');
          text.id = 'info_text_right';
          text.innerHTML = `<strong>${date.fontcolor('white')}</strong>`;
          return text;
        },
      });
      if (self.rightTextbox !== null) {
        self.rightTextbox.remove(self.map);
      }
      self.rightTextbox = new L.Control.textbox();
      self.rightTextbox.addTo(self.map);
    },
    addTimeLeftTextToMap(date) {
      const self = this;
      L.Control.textbox = L.Control.extend({
        options: {
          position: 'topleft',
        },
        onAdd() {
          const text = L.DomUtil.create('div');
          text.id = 'info_text_left';
          text.innerHTML = `<strong>${date.fontcolor('white')}</strong>`;
          return text;
        },
      });
      if (self.leftTextbox !== null) {
        self.leftTextbox.remove(self.map);
      }
      self.leftTextbox = new L.Control.textbox();
      self.leftTextbox.addTo(self.map);
    },
    openLayerDataPopup(properties, e, extra = {}) {
      let htmlString = "<div class='popup-content'>";
      htmlString += extra.before || '';
      let listHtml = '<ul>';
      listHtml += this.getLayerDataPropertiesHtml(properties);
      listHtml += '</ul>';
      htmlString += `${listHtml}</div>`;
      htmlString += extra.after || '';
      this.openPopup(htmlString, e.latlng);
    },
    getLayerDataPropertiesHtml(properties) {
      let listHtml = '';
      const bands = 'Band1';
      let result = 0;
      if (bands in properties) {
        switch (this.index) {
          case 'NDVI':
            result = (properties.Band8 - properties.Band4) / (properties.Band8 + properties.Band4);
            break;
          case 'SAVI':
            result = ((properties.Band8 - properties.Band4) / (properties.Band8 + properties.Band4 + 0.428)) * 0.428;
            break;
          case 'GNDVI':
            result = (properties.Band8 - properties.Band3) / (properties.Band8 + properties.Band3);
            break;
          case 'ARVI':
            result = (properties.Band8 - (2 * properties.Band4) + properties.Band2) / (properties.Band8 + (2 * properties.Band4) + properties.Band2);
            break;
          case 'AVI':
            result = ((properties.Band8 * (1 - properties.Band4) * (properties.Band8 - properties.Band4)) ** 1 / 3);
            break;
          case 'EVI':
            result = 2.5 * ((properties.Band8 - properties.Band4) / (properties.Band8 + 6 * properties.Band4 - 7.5 * properties.Band2 + 1));
            break;
          case 'VARI':
            result = (properties.Band3 - properties.Band4) / (properties.Band3 + properties.Band4 - properties.Band2);
            break;
          case 'LAI':
            result = 0.57 ** (2.33 * ((properties.Band8 - properties.Band4) / (properties.Band8 + properties.Band4)));
            break;
          case 'NDRE':
            result = (properties.Band8 - properties.Band5) / (properties.Band8 + properties.Band5);
            break;
          case 'RECI':
            result = (properties.Band8 - properties.Band11) / (properties.Band8 + properties.Band11);
            break;
          case 'NDMI':
            result = properties.Band8 / (properties.Band8 + properties.Band11);
            break;
          case 'MSI':
            result = properties.Band11 / properties.Band8;
            break;
          case 'GCI':
            result = (properties.Band9 / properties.Band3) - 1;
            break;
          case 'NBRI':
            result = properties.Band8 / (properties.Band8 + properties.Band2);
            break;
          default:
          case 'BSI':
            result = (properties.Band11 + properties.Band4) - (properties.Band8 + properties.Band2) / (properties.Band11 + properties.Band4) + (properties.Band8 + properties.Band2);
            break;
        }
        listHtml += `<li><b>${this.index}</b>: ${result.toFixed(2)}</li>`;
      } else {
        for (const property in properties) {
          if (properties[property] == null) continue;
          if (typeof properties[property] === 'object') {
            listHtml += this.getLayerDataPropertiesHtml(properties[property]);
          } else {
            listHtml += `<li><b>${property}</b>: ${properties[property]}</li>`;
          }
        }
      }
      return listHtml;
    },
    openPopup(html, latlng) {
      this.map.openPopup(html, latlng, {
        maxHeight: 4000,
      });
    },
    ...mapActions('Gis', ['setCurrentLayersMap', 'setCurrentOverlayLayer', 'fetchFeatureInfo', 'fetchDatesLayer']),
  },
};
</script>
<style>
  @import './Map.styles.scss';
  @import 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
  @import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css';
</style>
